import React, { useState } from 'react'
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import moment from "moment"
import { Field as FormikField, Form as FormikForm, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import Title from "../components/global/Title/Title"
import Notification from "../components/global/Notification/Notification"
import Button from "../components/global/Button/Button"
import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"
import { Loader } from "../components/common/Loader/Loader"

import { ReactComponent as Arrow } from "../assets/arrow.svg"

export default class InternationalScreen extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      loading: false,
      visible: false,
      value: '',
      error: '',
      data: [],
    }
    this.forceUpdate = this.forceUpdate.bind(this);
  }

  componentWillUnmount() {
    this.forceUpdate()
  }

  loadData = ({password}) => {
    this.setState({loading: true})
    axios.request(`/wp-json/wp/v2/pages/727?password=${password}`)
    .then(response => {
      if(response) {
        this.setState({
          data: response.data,
          loading: false,
          visible: true
        })
      }
    })
    .catch(error => {
      this.setState({loading: false})
      console.clear()
      alert("Ingevoerd wachtwoord is onjuist.");
      console.log(error);
    })
    // .catch(error => {
    //   if (error.response) {
    //     console.log(error.response.data);
    //     if(error.response.status === 403){
    //       alert("Onjuist wachtwoord.");
    //       console.log("lol");
    //     }
    //     console.log(error.response.headers);
    //   }
    // })
  }

  render() {
    const { data, loading, visible } = this.state

    const PasswordSchema = Yup.object().shape({
      password: Yup.string()
      .typeError('Wachtwoord is verplicht.')
      .required('Wachtwoord is verplicht.'),
    });

    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-full pt-32 pb-8">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                {data && data.title && ( <>
                  <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                  <div className="breadcrumb" style={{color: "#000"}}>{data.title && data.title.rendered}</div>
                  </>)}
                </div>
                <Title level="1" className="underlined">{data.title && data.title.rendered}</Title>
              </div>
              <div className="w-full md:mx-1-col">
                { visible  ? (
                  <div>
                    <Content className="mt-10 xs:w-full w-2/3">{ data.content && data.content.rendered }</Content>
                    <div className="md:-mx-2">
                      {data.acf && data.acf.files && data.acf.files.slice(0).reverse().map(prop =>
                        <div key={prop.file.id} className="w-full inline-block md:w-6/12 lg:w-6/12 px-4 my-4">
                          <div className="relative rounded-lg shadow-lg bg-white z-50 p-6">
                            <div className="w-full inline-flex mb-2 leading-10 align-middle">
                              <div className="font-bold text-xl">{prop.filename}</div>
                            </div>
                            <p className="text-gray-700 text-base mb-4">Gepubliceerd op: {moment(prop.file.modified).format('LLL')}</p>
                            <a className="text-orange mr-4" href={prop.file.url} target="_blank" rel="noopener noreferrer">
                              <span>Downloaden</span>
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="md:-mx-2">
                    <Formik
                      initialValues={{ password: '' }}
                      validationSchema={PasswordSchema}
                      onSubmit={(values, { resetForm}) => {
                        // alert(JSON.stringify({...values}, null, 2))
                        this.loadData(values)
                        resetForm({ values: '' })
                      }}
                      >
                      {({ errors, touched, isSubmitting, status }) => (
                        <FormikForm className="bg-lightorange rounded md:py-16 md:px-20 xs:py-8 xs:px-10 mb-4" method="POST">
                          <div className="flex flex-wrap -mx-3 mb-2">
                            <div className="w-full px-3">
                              <p>Dit is een beschermde omgeving. Voer het wachtwoord in om dit te kunnen bekijken.</p>
                              <FormikField placeholder="Wachtwoord" type="password" name="password" autoComplete="on" className={`appearance-none block w-full active:bg-white-100 rounded my-2 py-3 px-8 leading-10 focus:outline-none focus:bg-white ${errors.name && touched.name ? 'invalid' : null}`} />
                              {errors.name && touched.name &&
                                <div className="rounded h-8 mb-2 text-xs ease-in-out duration-300"><ErrorMessage name="name"/></div>
                              }
                            </div>
                          </div>
                          <div className="flex flex-wrap -mx-3 mb-2 items-center">
                            <div className="w-full md:w-1/2 px-3">
                              <Button type="submit" disabled={isSubmitting}>Verzenden</Button>
                            </div>
                          </div>
                        </FormikForm>
                      )}
                    </Formik>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      )
    }
  }
